import TitleBlock from './TitleBlock'
import ButtonEl from './ctas/Button'

/**
 * Header layout used by cardListCurated sections.
 * Renders the title/description on the left and CTA buttons on the right,
 * followed by a divider rule when any of those are present.
 */
const hasContent = (str) =>
  !!(
    str &&
    str
      .replace(/(<([^>]+)>)/gi, '')
      .replace(/&nbsp;/gi, '')
      .trim()
  )

const SectionLayoutCurated = ({ sectionProps, titleBlockDescClass }) => {
  const hasTitleBlock =
    sectionProps.sectionTitle !== false && (hasContent(sectionProps.title) || hasContent(sectionProps.description))
  const hasCtas = sectionProps.ctaLinkItem && sectionProps.ctaLinkItem.length > 0
  const hasDivider = hasContent(sectionProps.title) || hasContent(sectionProps.description)

  if (!hasTitleBlock && !hasCtas) {
    return null
  }

  return (
    <>
      <div className="flex flex-row items-center justify-between gap-6 md:gap-8 mb-8">
        {hasTitleBlock && (
          <div className="flex-1 [&_*]:!my-0">
            <TitleBlock
              {...sectionProps}
              descriptionClass={titleBlockDescClass}
              headingClass={'text-(--color-primary-text) !font-light'}
            />
          </div>
        )}

        {hasCtas && (
          <div className="flex flex-wrap gap-4 shrink-0 w-full">
            {sectionProps.ctaLinkItem.map((ctaLinkItem, i) => {
              // Downloadable CTAs carry media metadata; surface the extension + size as a
              // second line (matching the downloadable card layout) and skip the mobile
              // "View all" swap, which only makes sense for navigation CTAs.
              const fileMeta = [ctaLinkItem.mediaFileExtensionLabel, ctaLinkItem.mediaFileSizeFormatted]
                .filter(Boolean)
                .join(' ')
              return (
                <ButtonEl
                  key={i}
                  link={ctaLinkItem.link}
                  label={
                    fileMeta ? (
                      <span className="flex flex-col items-start leading-tight text-left">
                        <span>{ctaLinkItem.link?.name}</span>
                        <span className="text-sm font-normal opacity-80">{fileMeta}</span>
                      </span>
                    ) : (
                      <>
                        <span className="md:hidden">View all</span>
                        <span className="hidden md:inline">{ctaLinkItem.link?.name}</span>
                      </>
                    )
                  }
                  icon={ctaLinkItem.linkIconClass}
                  position={ctaLinkItem.linkPosition}
                  theme={ctaLinkItem.linkType.toLowerCase()}
                  className={`${!sectionProps.backgroundColor && ctaLinkItem.linkType.toLowerCase() === 'text' ? 'text-(--color-primary-text) !font-normal !text-lg' : ''}`}
                />
              )
            })}
          </div>
        )}
      </div>

      {hasDivider && <hr className="w-full mt-8 border-t border-(--color-border-tertiary)" />}
    </>
  )
}

export default SectionLayoutCurated
